import { giveawayModel } from 'entities/giveaway';
import { createAppAsyncThunk, logger } from 'shared';

import { actionTypes } from '../action-types';
import { giveawayApi } from '../api';

export const getReferrals = createAppAsyncThunk(
  actionTypes.GET_REFERRALS,
  async (any, { rejectWithValue, dispatch }) => {
    try {
      const {
        data: { referralCount, pointsEarned },
      } = await giveawayApi.getReferrals();

      dispatch(
        giveawayModel.actions.updateGiveawayState({
          referralCount,
          referralPointsEarned: pointsEarned,
        }),
      );

      return null;
    } catch (err) {
      logger('getReferrals', err);
      return rejectWithValue(err);
    }
  },
);
